export const base_url = 'https://dpm.deppon.com:8881/dpm/dpm-main/'; // 生产地址
// export const base_url = 'http://192.168.68.117:8080/dpm/dpm-main/'; // 个人测试

export const detailInfoUrl = base_url + 'rollAd_getRollAdById.action'; // 详情
export const tabsInfoUrl = base_url + 'rollAd_getRollAdList.action'; // 列表



// WEBPACK FOOTER //
// ./src/tools/address.js